import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/dD6pYLeS5wiiBNvnQXkrtH/1._MOCKUP_HOGAR_BLINDADO.png', 'https://cdn.magicpatterns.com/uploads/6WqkUEARiohL8xfD2zrwiu/2._MOCKUP_NOCHES_SECAS_.png', 'https://cdn.magicpatterns.com/uploads/guuUVLvWHf6UKdKd8L61xe/3._MOCKUP_FRESCOS_Y_SEGUROS.png', 'https://cdn.magicpatterns.com/uploads/rwaaApR9Sn5n1wmLPkKrce/4._MOCKUP_ADIOS_BERRINCHES.png', 'https://cdn.magicpatterns.com/uploads/nCq2yt1nU1Rn49F2RFuxfY/5._MOCKUP_DULCES_SUENOS.png'];
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-[#FBF8F4] px-4 py-20 lg:py-0" data-id="element-99">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-100">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-[#6B8F71]/5 blur-3xl" data-id="element-101" />
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-[#D4C5B0]/10 blur-3xl" data-id="element-102" />
      </div>

      <div className="container mx-auto max-w-7xl relative z-10" data-id="element-103">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-104">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-105">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-[#3D3229] mb-6" data-id="element-106">
              El Pack de 10 E-books que transforma la vida familiar con{' '}
              <span className="text-[#5A7D60] italic" data-id="element-107">
                soluciones prácticas
              </span>{' '}
              y respetuosas
            </h1>

            <p className="text-lg md:text-xl text-[#5C4A3A]/80 mb-8 font-light leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-108">
              Guías claras para acompañar a tus hijos en los desafíos reales del
              día a día: piojos, pipí en la cama, berrinches, sueño,
              alimentación y más.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-109">
              <Button size="lg" className="group" onClick={() => {
              document.getElementById('final-cta')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-110">
                Acceder al Pack Completo ahora
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-111" />
              </Button>
            </div>

            <p className="mt-4 text-sm text-[#5C4A3A]/60" data-id="element-112">
              * Acceso inmediato y de por vida
            </p>
          </motion.div>

          {/* Visual Content - Collage */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="relative h-[400px] md:h-[500px] lg:h-[600px] w-full flex items-center justify-center" data-id="element-113">
            <div className="relative w-full h-full max-w-[500px] mx-auto" data-id="element-114">
              <motion.img src={images[3]} alt="Adiós Berrinches" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60%] z-30 drop-shadow-2xl rounded-lg" animate={{
              y: [0, -10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 6,
              ease: 'easeInOut'
            }} data-id="element-115" />
              <motion.img src={images[0]} alt="Hogar Blindado" className="absolute top-[20%] left-0 w-[45%] z-20 drop-shadow-xl rounded-lg -rotate-6" animate={{
              y: [0, -15, 0]
            }} transition={{
              repeat: Infinity,
              duration: 7,
              delay: 1,
              ease: 'easeInOut'
            }} data-id="element-116" />
              <motion.img src={images[4]} alt="Dulces Sueños" className="absolute top-[20%] right-0 w-[45%] z-20 drop-shadow-xl rounded-lg rotate-6" animate={{
              y: [0, -12, 0]
            }} transition={{
              repeat: Infinity,
              duration: 8,
              delay: 0.5,
              ease: 'easeInOut'
            }} data-id="element-117" />
              <motion.img src={images[1]} alt="Noches Secas" className="absolute bottom-[10%] left-[5%] w-[40%] z-10 drop-shadow-lg rounded-lg -rotate-12 opacity-90" data-id="element-118" />
              <motion.img src={images[2]} alt="Frescos y Seguros" className="absolute bottom-[10%] right-[5%] w-[40%] z-10 drop-shadow-lg rounded-lg rotate-12 opacity-90" data-id="element-119" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}